import * as AWS from 'aws-sdk'

export interface FileObject extends AWS.S3.Object {
  name: string
}

export enum ViewLayoutType {
  TABLE,
  GRID,
}

export interface UploadFile {
  id: string
  name: string
  size: number
  src: FileSrc
  type: string
  progress: number // in %
  uploadStarted: Date
}

export interface FileSrc {
  file: File
}